var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../../Tooltip';
import styles from './styles.scss';

var TinyLink = function TinyLink(_ref) {
  var icon = _ref.icon,
      tooltip = _ref.tooltip,
      rest = _objectWithoutProperties(_ref, ['icon', 'tooltip']);

  return React.createElement(
    Tooltip,
    {
      content: React.createElement(
        'span',
        { style: { whiteSpace: 'nowrap' } },
        tooltip
      ),
      moveBy: { x: 3, y: 15 },
      appendToParent: true
    },
    React.createElement(
      'a',
      _extends({ className: styles.link + ' ' + styles.tinyLink }, rest),
      React.createElement(
        'div',
        { className: styles.linkIcon },
        icon
      )
    )
  );
};

TinyLink.propTypes = {
  icon: PropTypes.node.isRequired,
  tooltip: PropTypes.string.isRequired
};

export default TinyLink;
//# sourceMappingURL=TinyLink.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/core/footer/TinyLink.js